export default __webpack_public_path__ + "images/9a02ce3f7a4eb0340fea96f7cec18ce1-sii.svg";